// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4316) return "static/chunks/ad2866b8-3d70ef3a72e5ee32.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"358b4aabe706abff","1597":"d4e3cefda869c9e3","2831":"52e02f88c2114640","8255":"1622b254146c766d"}[chunkId] + ".js";
};